import { ThemeName, THEMES } from "../theme";

export const getThemeLogo = (themeName: ThemeName | null) => {
  switch (themeName) {
    case THEMES["atlas-dark"].name:
      return THEMES["atlas-dark"].logo;
    case THEMES["atlas-light"].name:
      return THEMES["atlas-light"].logo;
    default:
      return THEMES["atlas-light"].logo;
  }
};

export const getThemeIconLogo = (themeName: ThemeName | null) => {
  switch (themeName) {
    case THEMES["atlas-dark"].name:
      return THEMES["atlas-dark"].iconLogo;
    default:
      return THEMES["atlas-light"].iconLogo;
  }
};

/**
 * Checks if the current theme is an Atlas theme.
 * Since only Atlas themes are available, this always returns true.
 * @returns {boolean} Always true (atlas-only mode)
 */
export const useAtlasTheme = () => {
  return true;
};
